import type { SVGProps } from 'react';
export const Drag = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M7.17 6.23c.92 0 1.66-.72 1.66-1.61S8.1 3 7.17 3 5.5 3.72 5.5 4.62c0 .89.75 1.61 1.67 1.61" />
    <path d="M12.83 6.23c.92 0 1.67-.72 1.67-1.61S13.75 3 12.83 3s-1.66.72-1.66 1.62c0 .89.74 1.61 1.66 1.61" />
    <path d="M7.17 11.62c.92 0 1.66-.73 1.66-1.62S8.1 8.38 7.17 8.38 5.5 9.11 5.5 10s.75 1.62 1.67 1.62" />
    <path d="M12.83 11.62c.92 0 1.67-.73 1.67-1.62s-.75-1.62-1.67-1.62-1.66.73-1.66 1.62.74 1.62 1.66 1.62" />
    <path d="M7.17 17c.92 0 1.66-.72 1.66-1.62 0-.89-.74-1.61-1.66-1.61s-1.67.72-1.67 1.61S6.25 17 7.17 17" />
    <path d="M12.83 17c.92 0 1.67-.72 1.67-1.62 0-.89-.75-1.61-1.67-1.61s-1.66.72-1.66 1.61S11.9 17 12.83 17" />
  </svg>
);
